//src/services/api/dashboardService.ts

import { awsConfig } from "../config/aws-config";
import { toast } from 'react-toastify'; // For user notifications
import type { Metrics } from "../../types/metrics";

export const dashboardService = {
  /**
   * Retrieves dashboard metrics.
   * Endpoint: GET /admin/dashboard
   * @param token - Bearer token for authorization.
   * @returns Dashboard metrics.
   */
  getDashboardMetrics: async (token: string): Promise<Metrics> => {
    const url = `${awsConfig.apiEndpoint}/admin/dashboard`;


    try {

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        mode: 'cors',
      });

      if (!response.ok) {
        const errorData = await parseErrorResponse(response);
        throw new Error(errorData.message || 'Failed to fetch dashboard metrics');
      }

      const data: Metrics = await response.json();


      return data;
    } catch (error: any) {
      toast.error(error.message || 'Failed to fetch dashboard metrics');
      throw error;
    }
  },
};

/** Generic error parser. */
const parseErrorResponse = async (response: Response): Promise<{ message: string }> => {
  try {
    const data = await response.json();
    return { message: data.message || 'An error occurred' };
  } catch {
    return { message: response.statusText || 'An error occurred' };
  }
};